import { ReactRenderer } from "@tiptap/react";
import {
  fixedSlashCommands,
  SlashCommandGroup,
  SlashCommandItem,
  slashCommands,
} from "./slashMenuList";
import { SuggestionOptions } from "@tiptap/suggestion";
import { CommandList, CommandListRef } from "./SlashCommandList";
import tippy, { Instance as TippyInstance } from "tippy.js";

// Create the suggestion configuration for the slash command
export const suggestion: Partial<SuggestionOptions> = {
  // Don't show slash command in readonly mode
  allow: ({ editor }) => editor.isEditable,
  items: ({ query }: { query: string }) => {
    if (query === "") return slashCommands;

    const searchText = query.toLowerCase();

    return slashCommands
      .map((group) => ({
        ...group,
        items: group.items.filter((item) => {
          return (
            item.title.toLowerCase().includes(searchText) ||
            item.description.toLowerCase().includes(searchText)
          );
        }),
      }))
      .filter((group) => group.items.length > 0);
  },
  // fixedItems: fixedSlashCommands,

  render: () => {
    let component: ReactRenderer<CommandListRef>;
    let popup: TippyInstance[];

    return {
      onStart: (props) => {
        component = new ReactRenderer(CommandList, {
          props: { ...props, fixedItems: fixedSlashCommands },
          editor: props.editor,
        });

        if (!props.clientRect) {
          return;
        }

        popup = tippy("body", {
          getReferenceClientRect: props.clientRect as () => DOMRect,
          appendTo: () => document.body,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: "manual",
          placement: "bottom-start",
        });
      },

      onUpdate(props) {
        component.updateProps(props);

        if (!props.clientRect) {
          return;
        }

        popup[0].setProps({
          getReferenceClientRect: props.clientRect as () => DOMRect,
        });
      },

      onKeyDown(props) {
        if (props.event.key === "Escape") {
          popup[0].hide();
          return true;
        }

        return component.ref?.onKeyDown(props.event) ?? false;
      },

      onExit() {
        popup[0]?.destroy();
        component?.destroy();
      },
    };
  },
};
